module.exports = __webpack_public_path__ + "img/Nonmotor_acc_3.e27f4ecd.jpg";